import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import {debounce} from 'underscore';

import DailyIntakeOutput from './../../components/DailyIntakeOutput/DailyIntakeOutput';
import * as actionTypes from './../../store/actions/dailyIntakeAction';
import * as actionTypesHelp from './../../store/actions/helpAction';
import fetchDailyIntakeAction from './../../store/actions/fetch/fetchDailyIntakeAction';
import fetchCalculateDerAction from './../../store/actions/fetch/fetchCalculateDerAction';
import Loader from './../../components/Loader/Loader';

import {getDateFormat} from './../../helpers/DateHelper';

/**
 * Critical Care container
 */
class DailyIntake extends Component {
  constructor(props) {
    super(props);
    this.calculateDer = true;
  }

  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.pendingDer !== nextProps.pendingDer) {
      if(nextProps.pendingDer === true){
        this.calculateDer = false;
      }
    }
    else{
      this.calculateDer = true;
    }
    return true;
  }

  render() {
    const {data, error, pending, defaultValues, setDer,
      idealBodyWeightReady, ready, animalTypeReady,
      weeksLitterReady, breedReady, physicalActivityReady, bodyConditionReady,
      diagnosesReady, fetchDer, openModalWithContent} = this.props;
    // If there is a need for default data
    if(!ready && !error && !pending && idealBodyWeightReady
      && animalTypeReady && weeksLitterReady && breedReady
      && physicalActivityReady && bodyConditionReady && diagnosesReady){
      defaultValues();
    }
    // If Animal type data is pending
    if(pending || !ready) return (
      <Loader/>
    );
    const {birthReady, genderReady, conditionScoreReady,
      weightAdjustmentReady, criticalCareReady, productsReady} = this.props;
    if(idealBodyWeightReady && animalTypeReady && weeksLitterReady &&
      breedReady && physicalActivityReady && bodyConditionReady &&
      diagnosesReady && birthReady && genderReady && conditionScoreReady &&
      weightAdjustmentReady && criticalCareReady && productsReady
    ){
      // DER
      const {
        speciesId,
        breedId,
        sterilisedId,
        currentBodyWeight,
        goalWeight,
        bodyConditionScore,
        durationId,
        intensityFieldId,
        environmentTemperature,
      } = this.props;
      let {
        pregnancyId,
        lactationId,
        litterSize,
        birth,
        products,
        diagnosesIds,
        isWeightAdjustment,
        isCriticalCare,
        isMale
      } = this.props;
      if (isWeightAdjustment === null || isWeightAdjustment === false){
        isWeightAdjustment = 0;
      }
      else{
        isWeightAdjustment = 1;
      }
      if (isCriticalCare === null || isCriticalCare === false){
        isCriticalCare = 0;
      }
      else{
        isCriticalCare = 1;
      }

      if (isMale === null || isMale === false || isMale == "female"){
        isMale = 0;
      }  else{
        isMale = 1;
      }

      if (pregnancyId ===null){
        pregnancyId = -1;
      }
      if (lactationId ===null){
        lactationId = -1;
      }
      if (litterSize ===null){
        litterSize = -1;
      }
      if (birth ===null){
        birth = -1;
      }
      else{
        // birth = moment(birth).format(getDateFormat());
        birth = birth;
      }
      products = JSON.stringify(products);
      diagnosesIds = JSON.stringify(diagnosesIds);
      if(this.calculateDer){
        fetchDer(
          speciesId,
          breedId,
          birth,
          isMale,
          sterilisedId,
          pregnancyId,
          lactationId,
          litterSize,
          currentBodyWeight,
          goalWeight,
          bodyConditionScore,
          isWeightAdjustment,
          durationId,
          intensityFieldId,
          environmentTemperature,
          diagnosesIds,
          isCriticalCare,
          products
        );
      }
    }
    // DER
    const {errorDer, pendingDer, dataDer} = this.props;
    let der = 0;
    if(!pendingDer && !errorDer){
      der = dataDer.der;
    }
    setDer(der);
    // Return switcher
    return (
      <div className='nppe2-fc-daily-intake-output__wrapper'>
        {error && <span className='nppe2-fc-daily-intake-output__error'>{error}</span>}
        {!error &&
        <DailyIntakeOutput
          data={data}
          der={der}
          openModalWithContent={openModalWithContent}
        />
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.dailyIntakeReducer.error,
    data: state.dailyIntakeReducer.data,
    pending: state.dailyIntakeReducer.pending,
    ready: state.dailyIntakeReducer.ready,
    // Ready
    idealBodyWeightReady: state.idealBodyWeightReducer.ready,
    animalTypeReady: state.animalTypeReducer.ready,
    weeksLitterReady: state.weeksLitterReducer.ready,
    breedReady: state.breedReducer.ready,
    physicalActivityReady: state.physicalActivityReducer.ready,
    bodyConditionReady: state.bodyConditionReducer.ready,
    diagnosesReady: state.diagnosesReducer.ready,
    birthReady: state.birthDateReducer.ready,
    genderReady: state.genderReducer.ready,
    conditionScoreReady: state.conditionScoreReducer.ready,
    weightAdjustmentReady: state.weightAdjustmentReducer.ready,
    criticalCareReady: state.criticalCareReducer.ready,
    productsReady: state.productsReducer.ready,
    //DER Calculation
    speciesId: state.animalTypeReducer.selectedId,
    breedId: state.breedReducer.selectedData.id,
    birth: state.birthDateReducer.selected,
    isMale: state.genderReducer.selected,
    sterilisedId: state.weeksLitterReducer.sterilisedFactorId,
    pregnancyId: state.weeksLitterReducer.pregnancyFactorId,
    lactationId: state.weeksLitterReducer.lactationFactorId,
    litterSize: state.weeksLitterReducer.selectedLitter,
    currentBodyWeight: state.bodyConditionReducer.selectedBodyWeight,
    goalWeight: state.bodyConditionReducer.selectedGoalWeight,
    bodyConditionScore: state.conditionScoreReducer.selected,
    isWeightAdjustment: state.weightAdjustmentReducer.selected,
    durationId: state.physicalActivityReducer.selectedDurationId,
    intensityFieldId: state.physicalActivityReducer.selectedIntensity,
    environmentTemperature: state.physicalActivityReducer.selectedTemperature,
    diagnosesIds: state.diagnosesReducer.selectedIds,
    isCriticalCare: state.criticalCareReducer.selected,
    products: state.productsReducer.selected,
    // Products Data
    errorDer: state.calculateDerReducer.error,
    dataDer: state.calculateDerReducer.data,
    pendingDer: state.calculateDerReducer.pending,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchDailyIntakeAction,
      },
      dispatch,
    ),
    openModalWithContent: (key) => dispatch({
      type: actionTypesHelp.OPEN_MODAL_WITH_CONTENT,
      key: "DailyIntake",
      open: true,
    }),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
    setDer: (der) => dispatch({
      type: actionTypes.SET_DER,
      der: der,
    }),
    fetchDer: debounce((
      speciesId,
      breedId,
      birth,
      isMale,
      sterilisedId,
      pregnancyId,
      lactationId,
      litterSize,
      currentBodyWeight,
      goalWeight,
      bodyConditionScore,
      isWeightAdjustment,
      durationId,
      intensityFieldId,
      environmentTemperature,
      diagnoses,
      isCriticalCare,
      products
    ) => dispatch(fetchCalculateDerAction(
      speciesId,
      breedId,
      birth,
      isMale,
      sterilisedId,
      pregnancyId,
      lactationId,
      litterSize,
      currentBodyWeight,
      goalWeight,
      bodyConditionScore,
      isWeightAdjustment,
      durationId,
      intensityFieldId,
      environmentTemperature,
      diagnoses,
      isCriticalCare,
      products
    )), 150),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(DailyIntake);
